import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { useTranslate } from 'src/localization/Trns'

type MccRetailIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccRetailIcon(props: MccRetailIconProps) {
  const translate = useTranslate()
  const { className = '', ['aria-label']: ariaLabel, ...rest } = props
  return (
    <svg
      className={cn('MccRetailIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel ?? translate('Retail')}
      {...rest}
    >
      <path
        d="M3.68 1.75992L2.64 3.14658C2.43401 3.42124 2.33102 3.55856 2.33341 3.67351C2.33549 3.77355 2.38239 3.86735 2.46117 3.92904C2.55169 3.99992 2.72335 3.99992 3.06667 3.99992H12.9333C13.2766 3.99992 13.4483 3.99992 13.5388 3.92904C13.6176 3.86735 13.6645 3.77355 13.6666 3.67351C13.669 3.55856 13.566 3.42124 13.36 3.14658L12.32 1.75992M3.68 1.75992C3.79733 1.60347 3.856 1.52525 3.93035 1.46884C3.9962 1.41887 4.07077 1.38158 4.15026 1.35888C4.24 1.33325 4.33778 1.33325 4.53333 1.33325H11.4667C11.6622 1.33325 11.76 1.33325 11.8497 1.35888C11.9292 1.38158 12.0038 1.41887 12.0697 1.46884C12.144 1.52525 12.2027 1.60347 12.32 1.75992M3.68 1.75992L2.42667 3.43103C2.26836 3.6421 2.18921 3.74764 2.133 3.86387C2.08312 3.967 2.04675 4.07613 2.02477 4.18856C2 4.31526 2 4.44718 2 4.71103L2 12.5333C2 13.28 2 13.6534 2.14532 13.9386C2.27316 14.1895 2.47713 14.3934 2.72801 14.5213C3.01323 14.6666 3.3866 14.6666 4.13333 14.6666L11.8667 14.6666C12.6134 14.6666 12.9868 14.6666 13.272 14.5213C13.5229 14.3934 13.7268 14.1895 13.8547 13.9386C14 13.6534 14 13.28 14 12.5333V4.71103C14 4.44718 14 4.31526 13.9752 4.18856C13.9533 4.07613 13.9169 3.967 13.867 3.86387C13.8108 3.74764 13.7316 3.64211 13.5733 3.43103L12.32 1.75992M10.6667 6.66658C10.6667 7.37383 10.3857 8.05211 9.88562 8.5522C9.38552 9.0523 8.70724 9.33325 8 9.33325C7.29276 9.33325 6.61448 9.0523 6.11438 8.5522C5.61428 8.05211 5.33333 7.37383 5.33333 6.66658"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
